import { render, staticRenderFns } from "./CImg.vue?vue&type=template&id=2f299766&scoped=true&"
import script from "./CImg.vue?vue&type=script&lang=ts&"
export * from "./CImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f299766",
  null
  
)

export default component.exports